import { Outlet, useMatch, useOutletContext } from "react-router";
import { QueueList } from "../../components/QueueList";
import s from "./QueueScreen.module.css";

export function QueueScreen() {
  const viewingCustomer = useMatch("/queue/:customerId") !== null;
  // Outlet context doesn't inherit through nested outlets; without this the workspace never sees the staff user.
  const staffUser = useOutletContext();

  return (
    <div className={viewingCustomer ? `${s.root} ${s.viewingCustomer}` : s.root}>
      <div className={s.listSlot}>
        <QueueList />
      </div>
      <div className={s.workspaceSlot}>
        <Outlet context={staffUser} />
      </div>
    </div>
  );
}
